import type { ReactElement } from 'react';
import { default as Logo } from 'src/assets/images/logos/miliboo-dp-min.svg?react';
import { DocumentTitle } from 'src/components/DocumentTitle';

type SplashScreenProps = {
  loadingLabel: string;
  title: string;
};

export function SplashScreen({
  loadingLabel,
  title,
}: SplashScreenProps): ReactElement {
  return (
    <div className='fixed inset-0 flex items-center justify-center bg-layout'>
      <DocumentTitle suffix={false} title={title} />
      <div className='flex flex-col items-center space-y-6'>
        <div className='relative'>
          <div className='absolute inset-0 animate-ping rounded-full bg-primary-default/20'></div>
          <div className='relative'>
            <Logo className='h-16 w-16 text-primary-default' />
          </div>
        </div>
        <div className='text-center'>
          <h1 className='font-bold text-2xl text-layout-foreground'>{title}</h1>
          <p className='mt-1 text-layout-foreground-secondary text-sm'>
            {loadingLabel}
          </p>
        </div>
        <div className='flex space-x-1'>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default [animation-delay:-0.3s]'></div>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default [animation-delay:-0.15s]'></div>
          <div className='h-2 w-2 animate-bounce rounded-full bg-primary-default'></div>
        </div>
      </div>
    </div>
  );
}
